export default "__VITE_ASSET__X1pW6Bcm__"